import React from "react";
import { Row, Col } from "antd";
import styled from 'styled-components';
import StrippingSchedule from "components/Schedule/StrippingSchedule";
import CenteredPageContainer from "components/Layout/CenteredPageContainer";

export interface Props {
    children?: React.ReactNode
}

export interface State {
}

const TallCol = styled(Col)`
  height: 100%;
  min-height: 200px;
`;


export default class StrippingSchedulePage extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <CenteredPageContainer title="Container Schedule">
                <StrippingSchedule />
            </CenteredPageContainer>
        )
    }
}
